
const modalStyles100Percent400Without = { maxHeight: '100%', width: '400px' };
const modalEditBill = {maxHeight: '100%', width: '500px'};

export const ForgotPasswordProps = {
  modalName: 'ForgotPasswordModal',
  styles: modalStyles100Percent400Without,
};

export const EditBillModalProps = {
  modalName: 'EditBillModal',
  styles: modalEditBill
}

export const ResetPasswordProps = {
  modalName: 'ResetPasswordModal',
  styles: modalStyles100Percent400Without,
};

export const DeleteModuleProps={
  modalName:'DeleteModuleModal',
  styles: modalStyles100Percent400Without,
}

export const ApproveModuleProps={
  modalName:'ApproveModuleModal',
  styles: modalStyles100Percent400Without,
}

export const SaveModuleProps={
  modalName:'SaveModuleModal',
  styles: modalStyles100Percent400Without,
}